import React, { useState } from 'react'
import { Card, CardBody, CardHeader, Col, Input, Label, Row, TabPane } from "reactstrap";

import { APIClient } from '../../../../../helpers/api_helper';
import { LEAD_BUIK_IMPORT } from '../../../../../helpers/url_helper';
import { ToastContainer } from 'react-toastify';
import Toast from '../../../../../Components/Common/Toast';

const api = new APIClient();

const BulkActions = ({ toggleArrowTab, activeArrowTab, files, setLeadSummary, setIsChecked, isChecked, setSelectedLabelText, setSelectedAssignLabelText,setActionSummary }) => {
  const [selectedLeadValue, setSelectedLeadValue] = useState('1');
  const [selectedAssignValue, setSelectedAssignValue] = useState('2');


  // Lead import function 
  const handleLeadImportRadioChange = (event, labelText) => {
    const selectedValue = event.target.value;
    setSelectedLeadValue(selectedValue);
    setSelectedLabelText(labelText)
  };

  // Assign Lead import function 
  const handleAssignImportRadioChange = (event, labelText) => {
    setSelectedAssignValue(event.target.value);
    setSelectedAssignLabelText(labelText)
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };



  const handleBulkAction = async () => {
    try {
      const formData = new FormData();
      formData.append('uploadCsv', files);
      // formData.append('filter', selectedLeadValue);
      formData.append('leadFilter', selectedLeadValue);
      formData.append('assignFilter', selectedAssignValue);
      formData.append('mapCallLogs', isChecked);

      const response = await api.create(LEAD_BUIK_IMPORT, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response && response?.success === true) {
        setLeadSummary(response)
        Toast(response.message, 'success')
        setActionSummary(true)
        toggleArrowTab(activeArrowTab + 1);
      }
    }
    catch (error) {
      Toast(error.response.data.message, 'error')
    }
  };


  return (
    <>
      <ToastContainer />
      <TabPane id="steparrow-extra-info" tabId={7}>
        <div>
          <Row>
            <Col sm={12} className="mt-4">
              <Row>
                <Col xxl={6}>
                  <Card className="border card-border-danger sn-bulk-managment-tabs-box-red">
                    <CardHeader>
                      <div className="d-flex align-items-center">
                        <h6 className="card-title mb-0">
                          <i className="ri-check-double-line label-icon text-danger"></i>{" "}
                          Lead Import Rules
                        </h6>
                      </div>
                    </CardHeader>
                    <CardBody>
                      <div className="sn-bulk-lead-box-list-main">
                        <ul>
                          {" "}
                          <h5>Handling duplicate Lead records</h5>
                          <li>
                            <div></div>
                            <div className="col-sm">
                              <Input
                                type="radio"
                                id="option1"
                                name="callLogGroup"
                                value="1"
                                checked={selectedLeadValue === '1'}
                                onChange={(e) => handleLeadImportRadioChange(e, "Overwrite duplicates")}
                                className="w-4 h-4 text-blue-600"
                              />

                              &nbsp;
                              <label
                                htmlFor="leadTermCheck"
                                className="custom-control-label dt-cursor"
                              >
                                <Label htmlFor="option1" for="leadTermCheck">
                                  Ignore duplicates - If a similar phone
                                  number is found, the system will skip
                                  the record from CSV.
                                </Label>
                              </label>
                            </div>
                          </li>
                          <li>
                            <div className="col-sm">
                              <Input
                                type="radio"
                                id="option2"
                                name="callLogGroup"
                                value="2"
                                checked={selectedLeadValue === '2'}
                                onChange={(e) => handleLeadImportRadioChange(e, "Overwrite duplicates")}
                                className="w-4 h-4 text-blue-600"
                              />
                              &nbsp;
                              <label
                                htmlFor="leadTermCheck1"
                                className="custom-control-label dt-cursor"
                              >
                                <Label htmlFor="option2" for="leadTermCheck1">
                                  Overwrite duplicates- If a similar phone
                                  number is found, the system will
                                  overwrite all the values.
                                </Label>
                              </label>
                            </div>
                          </li>
                          <li>
                            <div className="d-flex">
                              <Input
                                type="radio"
                                id="option3"
                                name="callLogGroup"
                                value="3"
                                checked={selectedLeadValue === '3'}
                                onChange={(e) => handleLeadImportRadioChange(e, "Update empty fields of duplicates")}
                                className="w-4 h-4 text-blue-600"
                              />
                              &nbsp;
                              <label
                                htmlFor="leadTermCheck78"
                                className="custom-control-label dt-cursor"
                              >
                                <Label htmlFor="option3" for="leadTermCheck78">
                                  Update empty fields of duplicates- If a
                                  similar phone number is found, the
                                  system will update only those
                                  information which are blank.
                                </Label>
                              </label>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </CardBody>
                  </Card>
                </Col>


                <Col xxl={6}>
                  <Card className="border card-border-danger sn-bulk-managment-tabs-box-red">
                    <CardHeader>
                      <div className="d-flex align-items-center">
                        <h6 className="card-title mb-0">
                          <i className="ri-check-double-line label-icon text-danger"></i>{" "}
                          Assign Lead(s) Rules
                        </h6>
                      </div>
                    </CardHeader>
                    <CardBody>
                      <div className="sn-bulk-lead-box-list-main">
                        <ul>
                          <h5>Select assign to options for lead</h5>
                          <li>
                            <Input
                              type="radio"
                              id="optionAssign1"
                              name="callLogLeadGroup"
                              value="1"
                              checked={selectedAssignValue === '1'}
                              onChange={(e) => handleAssignImportRadioChange(e, "Ignore duplicates")}
                              className="w-4 h-4 text-blue-600"
                            />
                            &nbsp;
                            <label
                              htmlFor="leadTermCheck0"
                              className="custom-control-label dt-cursor"
                            >
                              <Label htmlFor="optionAssign1" for="leadTermCheck0">
                                {" "}
                                <p>
                                  {" "}
                                  Ignore duplicates- If any lead is found
                                  already assigned to employee, then it
                                  will not assign to new employee
                                </p>
                              </Label>
                            </label>
                          </li>
                          <li>
                            <Input
                              type="radio"
                              id="optionAssign2"
                              name="callLogLeadGroup"
                              value="2"
                              checked={selectedAssignValue === '2'}
                              onChange={(e) => handleAssignImportRadioChange(e, "Overwrite duplicates")}
                              className="w-4 h-4 text-blue-600"
                            />
                            &nbsp;
                            <label
                              htmlFor="leadTermCheck11"
                              className="custom-control-label dt-cursor"
                            >
                              <Label htmlFor="optionAssign2" for="leadTermCheck11">
                                {" "}
                                <p>
                                  Overwrite Duplicates: If any lead is
                                  found already assigned to employee, then
                                  existing employee(s) will be overwrite
                                  to new employee(s).
                                </p>
                              </Label>
                            </label>
                          </li>
                          <li>
                            <Input
                              type="radio"
                              id="optionAssign3"
                              name="callLogLeadGroup"
                              value="3"
                              checked={selectedAssignValue === '3'}
                              onChange={(e) => handleAssignImportRadioChange(e, " Keep Existing and Assign to New")}
                              className="w-4 h-4 text-blue-600"
                            />
                            &nbsp;
                            <label
                              htmlFor="leadTermCheck22"
                              className="custom-control-label dt-cursor"
                            >
                              <Label htmlFor="optionAssign3" for="leadTermCheck22">
                                {" "}
                                <p>
                                  {" "}
                                  Keep Existing and Assign to New : If any
                                  lead is found already assigned to
                                  employee, it will keep existing
                                  employee(s) and also assign to new
                                  employee(s)
                                </p>
                              </Label>
                            </label>
                          </li>
                        </ul>
                      </div>
                    </CardBody>
                  </Card>
                </Col>


                <Col xxl={6}>
                  <div className="sn-bulk-managment-tabs-box-red">
                    <h5>Track Call Log</h5>
                    <p>
                      <Input
                        type="checkbox"
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                      />  Map available call logs of leads</p>
                    <p>System will check all the existing call logs and if any call matches with lead's numbers then it will be mapped.</p>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        <div className="d-flex texr-end mt-4 justify-content-end">
          <div className="text-end sn-bulk-next-back-btn">
            <button
              type="button"
              className="btn btn-light btn-label previestab"
              onClick={() => {
                toggleArrowTab(activeArrowTab - 2);
              }}
            >
              <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i> Back
            </button>
            <button
              type="button"
              className="btn btn-danger btn-label right ms-auto nexttab nexttab"
              onClick={() => handleBulkAction()}>

              <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
              Next
            </button>
          </div>
        </div>
      </TabPane>
    </>
  )
}

export default BulkActions
